<div class="route-component">
    <div class="form-component">

        <tab-control>
            <tab-page title="Renewal Reports" icon="fas fa-user-pen">
                <h4>
                    Select Report
                </h4>

                <form #form="ngForm" (ngSubmit)="onRunReport(form)">
                    <!-- Start Date -->
                    <div class="input-group">
                        <label for="startDate">
                            Start Date: <span class="required"> * </span>
                        </label>
                        <input type="date" name="startDate" [(ngModel)]="startDate" (input)="onEndDateInput()" required>
                        <div *ngIf="!startDate">
                            <span class="error">Start Date is required</span>
                        </div>
                    </div>

                    <!-- End Date -->
                    <div class="input-group">
                        <label for="endDate">
                            End Date: <span class="required"> * </span>
                        </label>
                        <input type="date" name="endDate" [(ngModel)]="endDate" (input)="onEndDateInput()"  required>
                        <div *ngIf="!endDate">
                            <span class="error">End Date is required</span>
                        </div>
                        <div *ngIf="endDateError">
                            <span class="error">The End Date cannot be set to a date before the Start Date</span>
                        </div>
                    </div>

                    <!-- Client -->
                    <div class="input-group">
                        <auto-complete-dropdown
                            [options]="clients"
                            [label]="'Client'"
                            [placeholder]="'Select a client...'"
                            [initialValue]="selectedClientId"
                            [required]="true"
                            [invalid]="!selectedClientId && formSubmitted"
                            [validationMessage]="'Client is required'"
                            (selectionChange)="onClientSelectionChange($event)">
                        </auto-complete-dropdown>
                    </div>

                    <!-- Policy -->
                    <div class="input-group" *ngIf="selectedClientId && clientAreas && clientAreas.length">
                        <auto-complete-dropdown
                            [options]="clientAreas"
                            [label]="'Policy'"
                            [placeholder]="'Select a policy...'"
                            [initialValue]="selectedClientAreaId"
                            [required]="true"
                            [invalid]="!selectedClientAreaId && formSubmitted"
                            [validationMessage]="'Policy is required'"
                            (selectionChange)="onClientAreaSelectionChange($event)">
                        </auto-complete-dropdown>
                    </div>

                    <!-- Report -->
                    <div class="input-group" *ngIf="selectedClientId && selectedClientAreaId && reports && reports.length">
                        <auto-complete-dropdown
                            [options]="reports"
                            [label]="'Report'"
                            [placeholder]="'Select a report...'"
                            [initialValue]="selectedReportId"
                            [required]="true"
                            [invalid]="!selectedReportId && formSubmitted"
                            [validationMessage]="'Report is required'"
                            [displayWith]="displayReport"
                            (selectionChange)="onReportSelectionChange($event)">
                        </auto-complete-dropdown>
                    </div>

                    <!-- Action Bar -->
                    <div class="action-bar">
                        <button type="submit" class="button" [disabled]="form.invalid || endDateError || isSaving">
                            <i class="fas fa-fire"></i>
                            Run Report
                        </button>
                    </div>
                </form>
            </tab-page>
        </tab-control>

    </div>
</div>